// extracted by mini-css-extract-plugin
export default {"root":"ValidationMessage-root-fd223f23247c3dfaf5b01c9e422fd63b","icon":"ValidationMessage-icon-570d7694872d54c67308e8fc9b5e5ce0"};